export default function CloudDownloadSVG(props) {
    return (
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M11.3334 11.3359L8.33337 14.3359L5.33337 11.3359M8.33337 14.3359V7.58594M14.3334 11.1431C15.2495 10.3865 15.8334 9.24189 15.8334 7.96094C15.8334 5.68276 13.9865 3.83594 11.7084 3.83594C11.5445 3.83594 11.3912 3.75043 11.308 3.60924C10.3299 1.94956 8.5242 0.835938 6.45837 0.835938C3.35177 0.835938 0.833374 3.35434 0.833374 6.46094C0.833374 8.01052 1.45996 9.41375 2.47359 10.4311" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
